define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var BaseController = require('web-agent-assets-js/BaseController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var PostSurvey = require('web-agent-assets-js/lpPostSurvey');

    var ENTITY_TYPE = {
        POST_SURVEY: 'postSurvey'
    };

    /////////////////////////////////// PRIVATE VARIABLES ///////////////////////////////////

    var logger;
    var postSurveyApi;
    var model;
    /////////////////////////////////// INITIALIZATION ///////////////////////////////////

    lpTag.lpPostSurveyController = BaseController.extend(function (options) {
        logger = this.logger || WebAgentLogger.getLogger(this.applicationType);
        model = options && options.model;
        postSurveyApi = new PostSurvey();

        // This will listen to records changes in the array and re-calculate the count and data objects.
        this.model.bind(ENTITY_TYPE.POST_SURVEY    + '.array', updateModelDataFromArray.bind(this, ENTITY_TYPE.POST_SURVEY   , getSinglePostSurveyObject    ));
    });
    var lpPostSurvey = lpTag.lpPostSurveyController;

    /////////////////////////////////// PUBLIC INSTANCE VARIABLES ///////////////////////////////////

    lpPostSurvey.prototype.applicationType = 'lpPostSurveyController';

    /////////////////////////////////// PUBLIC METHODS ///////////////////////////////////

    /**
     * Starts polling the post surveys (every 60 seconds)
     */
    lpPostSurvey.prototype.startPolling = function () {
        logger.info("", "startPolling");
        getPostSurvey();
    };

    /**
     * Stops polling the post surveys
     */
    lpPostSurvey.prototype.stopPolling = function () {
        logger.info("", "stopPolling");
        postSurveyApi.stopPolling();
    };

    /////////////////////////////////// PRIVATE METHODS ///////////////////////////////////

    /**
     * Update the model data based on the array, this will allow updating the data from multiple sources.
     * @param {String} name - the name of the data set in the model.
     */
    function updateModelDataFromArray(name, getSingleObject){
        var dataArray = model.get(name + '.array');
        if(dataArray){
            model.set(name + '.count', dataArray.length);
            var processedData = getProcessedObject(dataArray, getSingleObject);
            model.modify(name + '.data', processedData);
            model.set(name + '.state', {success: 'ok', itemsCount: dataArray.length});

        }
    }

    /**
     * Handles a successful request callback by processing the data using the provided callback,
     * and storing the data in the model.
     * @param data - The data returned in the response
     * @param name - The name to store the processed data under in the model
     * @param getSingleObject - The callback to process the data
     */
    function handleRequestSuccess(data, name) {
        var rawData = data.constructor === Array ? data : [data];
        model.modify(name + '.array', rawData, "id");
    }

    /**
     * Handles a request error by saving the error data to the model.
     * @param data - The error data
     * @param name - The name to store the data under in the model.
     */
    function handleRequestError(data, name) {
        model.set(name + '.state', {error: data || ''});
    }

    /**
     * Returns processed data based on an array of raw data and a callback used to process each item in the array.
     * @param rawArray - An array of raw data to be processed into an object by ID
     * @param getSingleObject - The callback to process a single item in the raw data array
     * @returns - An object containing processed objects by ID
     */
    function getProcessedObject(rawArray, getSingleObject) {
        var dataArray = rawArray;
        var processedObject = {};
        for (var i = 0; i < dataArray.length; i++) {
            var singleObject = getSingleObject(dataArray[i]);
            processedObject[dataArray[i].id] = singleObject;
        }
        return processedObject;
    }

    /**
     * Starts polling the post surveys (The API starts polling internally)
     */
    function getPostSurvey() {
        logger.info("", "getPostSurvey");
        var requestObj = {
            success: handlePostSurveySuccess,
            error: handlePostSurveyError
        };
        postSurveyApi.getPostSurvey(requestObj);
    }

    /**
     * Handles the success of a post survey request
     * @param data - The raw post survey data
     */
    function handlePostSurveySuccess(data) {
        logger.debug("PostSurvey return as Success", "handlePostSurveySuccess");
        if(data && data.statusCode !== 304){
            var dataToUse = [];
            if (data && data.body) {
                dataToUse = data.body;
            }
            handleRequestSuccess(dataToUse, 'postSurvey', getSinglePostSurveyObject);
        }
    }

    /**
     * Handles an error in post survey request
     * @param data - The error data
     */
    function handlePostSurveyError(data) {
        logger.error(JSON.stringify(data), "handlePostSurveyError");
        logger.graph({name: 'getPostSurveyError'});
        handleRequestError(data, 'postSurvey');
    }

    /**
     * Maps a single post survey object from its raw form to its final form
     * @param postSurveyObject - The post survey object
     * @returns - The processed post survey object
     */
    function getSinglePostSurveyObject(postSurveyObject) {
        return {
            id: postSurveyObject.id,
            name: postSurveyObject.name
        };
    }

    return lpTag.lpPostSurveyController;

});
